import { Controller } from "@hotwired/stimulus"

// Try again on a painted picture (dashboard/dropped_pictures/_painted): drag
// over the painted copy to box what the paint missed, or, starting over, over
// the original to box every logo. Each box is kept as [left, top, right,
// bottom], fractions of the picture, in the form's boxes field
// (PaintedPicture#send_back!). Picking the other picture clears the boxes.
export default class extends Controller {
  static targets = ["stage", "field", "hint"]

  connect() { this.boxes = [] }

  // The picture being drawn on: the one showing.
  get stage() { return this.stageTargets.find((stage) => !stage.hidden) }

  pick(event) {
    this.stageTargets.forEach((stage) => { stage.hidden = stage.dataset.from !== event.target.value })
    if (this.hasHintTarget) this.hintTarget.textContent = this.hintTarget.dataset[event.target.value]
    this.clear()
  }

  start(event) {
    if (event.button !== 0) return
    event.preventDefault()
    this.stage.setPointerCapture(event.pointerId)
    this.from = this.point(event)
    this.drawing = document.createElement("div")
    this.drawing.className = "dp-box"
    this.stage.appendChild(this.drawing)
    this.place(this.drawing, this.from, this.from)
  }

  move(event) {
    if (!this.drawing) return
    this.place(this.drawing, this.from, this.point(event))
  }

  end(event) {
    if (!this.drawing) return
    const to = this.point(event)
    const box = [Math.min(this.from.x, to.x), Math.min(this.from.y, to.y), Math.max(this.from.x, to.x), Math.max(this.from.y, to.y)]
    if (box[2] - box[0] < 0.01 || box[3] - box[1] < 0.01) {
      this.drawing.remove()
    } else {
      this.boxes.push(box.map((n) => Math.round(n * 10000) / 10000))
      this.fieldTarget.value = JSON.stringify(this.boxes)
    }
    this.drawing = null
  }

  clear() {
    this.boxes = []
    this.fieldTarget.value = "[]"
    this.element.querySelectorAll(".dp-box").forEach((box) => box.remove())
  }

  // Where the pointer is over the picture, as fractions of it.
  point(event) {
    const rect = this.stage.querySelector("img").getBoundingClientRect()
    const clamp = (n) => Math.min(Math.max(n, 0), 1)
    return { x: clamp((event.clientX - rect.left) / rect.width), y: clamp((event.clientY - rect.top) / rect.height) }
  }

  place(element, a, b) {
    element.style.left = `${Math.min(a.x, b.x) * 100}%`
    element.style.top = `${Math.min(a.y, b.y) * 100}%`
    element.style.width = `${Math.abs(a.x - b.x) * 100}%`
    element.style.height = `${Math.abs(a.y - b.y) * 100}%`
  }
}
